"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberSelect = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

require("./NumberSelect.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const NumberSelect = _ref => {
  let {
    value,
    setValue,
    min = 1,
    max = 10,
    size = 5,
    color = 'white',
    numberBgColor = '#663399',
    selectorColor = '#1E90FF',
    timeout = 1000,
    onOpenInput,
    closed
  } = _ref;
  const [editing, setEditing] = (0, _react.useState)(false);
  const [doneClosing, setDoneClosing] = (0, _react.useState)(true);
  const [closeTimeout, setCloseTimeout] = (0, _react.useState)();
  const [doneClosingTimeout, setDoneClosingTimeout] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (closed) close();
  }, [closed]);

  const close = () => {
    clearTimeout(closeTimeout);
    setEditing(false);
    setCloseTimeout(undefined);
    startDoneClosingTimeout();
  };

  const startCloseTimeout = () => {
    if (!timeout) return;
    clearTimeout(closeTimeout);
    setCloseTimeout(setTimeout(close, timeout));
  };

  const startDoneClosingTimeout = () => {
    clearTimeout(doneClosingTimeout);
    setDoneClosingTimeout(setTimeout(() => {
      setDoneClosing(true);
      setDoneClosingTimeout(undefined);
    }, 200));
  };

  const fullSize = "".concat(size, "rem");
  const incrementorSize = "".concat(size * .8, "rem");
  const incrementorVerticalOffset = "-".concat(size * .9, "rem");
  const incrementorHorizontalOffset = "".concat(size * .1, "rem");
  const minusHalfSize = "-".concat(size / 3, "rem");
  const incrementorStyle = {
    height: incrementorSize,
    width: incrementorSize,
    backgroundColor: selectorColor,
    right: incrementorHorizontalOffset,
    bottom: incrementorHorizontalOffset
  };

  const addStyle = _objectSpread(_objectSpread({}, incrementorStyle), {}, {
    top: editing ? incrementorVerticalOffset : 0
  });

  const subtractStyle = _objectSpread(_objectSpread({}, incrementorStyle), {}, {
    bottom: editing ? incrementorVerticalOffset : 0
  });

  const blurStyle = {
    background: "radial-gradient(".concat(numberBgColor, "FF, ").concat(numberBgColor, "00, ").concat(numberBgColor, "00)"),
    left: minusHalfSize,
    right: minusHalfSize,
    top: incrementorVerticalOffset,
    bottom: incrementorVerticalOffset
  };

  const icon = up => /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: color
  }, up ? /*#__PURE__*/_react.default.createElement("path", {
    d: "m283-345-43-43 240-240 240 239-43 43-197-197-197 198Z"
  }) : /*#__PURE__*/_react.default.createElement("path", {
    d: "M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z"
  }));

  const increment = change => () => {
    startCloseTimeout();
    const nv = change + value;
    if (nv > max || nv < min) return;
    setValue(nv);
  };

  const renderInputs = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "numberSelect_input ".concat(editing ? '' : 'numberSelect_input-hidden')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'numberSelect_increment numberSelect_add',
    style: addStyle,
    onClick: increment(1)
  }, icon(true)), /*#__PURE__*/_react.default.createElement("div", {
    className: "numberSelect_blur",
    style: blurStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "numberSelect_increment numberSelect_subtract",
    style: subtractStyle,
    onClick: increment(-1)
  }, icon()));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "numberSelect ".concat(editing ? 'numberSelect_editing' : '', " ").concat(doneClosing ? 'numberSelect_doneClosing' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "numberSelect_value",
    onClick: () => {
      if (!editing) {
        startCloseTimeout();
        onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput();
        setDoneClosing(false);
        setEditing(true);
      } else {
        close();
      }
    },
    style: {
      height: fullSize,
      width: fullSize,
      color,
      backgroundColor: numberBgColor,
      fontSize: "".concat(size / 2, "rem")
    }
  }, value), renderInputs());
};

exports.NumberSelect = NumberSelect;